<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="zone flex flex-center">
      <div class="zone-inner">
        <div class="zone-path">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>联盟专区</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="zone-block" v-loading="loading">
          <div v-for="(item, index) in lists" :key="index" class="league">
            <div class="flex flex-row flex-between league-name">
              <div class="league-icoWrap flex flex-row flex-middle">
                <img
                  v-if="item.leagueIco"
                  :src="item.leagueIco"
                  class="league-ico"
                />
                <div class="pointer" @click="zoneClick(item)">
                  {{ item.leagueName }}
                </div>
              </div>
              <div></div>
              <div class="league-add pointer" @click.stop="joinAlliance(item)">
                <i class="el-icon-circle-plus"></i>
                <span>加入联盟</span>
              </div>
            </div>
            <div class="league-brief">
              {{ item.leagueBrief }}
            </div>
            <div class="flex flex-row">
              <div class="member flex flex-row flex-between">
                <div class="flex flex-row flex-middle">
                  <img
                    :src="$oss('alliance/icon-member.png')"
                    class="member-icon"
                  />
                  <div>联盟成员</div>
                </div>

                <div class="member-right flex flex-middle">
                  <div class="member-num">{{ item.memberNum }}</div>
                </div>
              </div>
              <div class="activity flex flex-row">
                <div class="flex flex-row flex-middle">
                  <img
                    :src="$oss('alliance/icon-activity.png')"
                    class="activity-icon"
                  />
                  <div class="activity-label">最新活动</div>
                </div>
                <div class="flex-1">
                  <div class="activity-name">
                    {{ item.newActivityName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页-->
        <Pagination
          :total="totalItem"
          :page="page"
          @pageIndexChange="handlePageChange"
        />
      </div>
    </div>

    <FootBar />
  </div>
</template>
<script>
import { allianceList } from "@/api/allianceZone";
import Pagination from "@/components/Pagination/index";
import { mapGetters } from "vuex";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalItem: 0,
      lists: [],
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  created() {
    this.getList();
  },
  methods: {
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getList();
    },
    async getList() {
      this.loading = true;
      const { list, totalItem } = await this.$axios
        .get(allianceList, {
          ...this.page,
        })
        .finally(() => {
          this.loading = false;
        });
      this.lists = list;
      this.totalItem = totalItem;
    },
    joinAlliance(item) {
      if (!this.token) {
        this.$store.dispatch("login");
        return;
      }
      this.$router.push({
        name: "joinAlliance",
        query: { allianceId: item.leagueId },
      });
    },
    zoneClick(item) {
      this.$router.push({
        name: "allianceDetail",
        query: { id: item.leagueId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.member,
.activity {
  width: 272px;
  border-radius: 8px;
  padding: 10px;
  color: white;
  font-weight: 400;
  &-icon {
    width: 40px;
    height: 40px;
  }
}
.member {
  background: linear-gradient(90deg, #1082bd 0%, #005ca7 100%);
  margin-right: 20px;
  &-right {
    color: white;
    text-align: center;
  }
  &-num {
    font-size: 18px;
    font-weight: bold;
  }
}
.activity {
  background: linear-gradient(90deg, #ff9531 0%, #fb553f 100%);
  color: white;
  &-name {
    font-size: 12px;
    max-width: 132px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  &-label {
    font-weight: bold;
    margin-right: 16px;
  }
}
.league {
  background: white;
  margin-bottom: 15px;
  padding: 15px;
  &-ico {
    width: 27px;
    height: 27px;
    object-fit: contain;
    margin-right: 8px;
  }
  &-icoWrap {
    margin-right: 15px;
  }
  &-name {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
  }
  &-brief {
    color: #777777;
    margin: 16px 0 25px 0;
  }
  &-add {
    color: $theme-color;
    font-size: 14px;
    i {
      margin-right: 5px;
      font-size: 18px;
      position: relative;
      top: 2px;
    }
  }
}
.zone {
  background: $home-bg;
  padding-top: 20px;
  &-inner {
    width: $max-width;
    min-height: 500px;
    padding-bottom: 20px;
  }
  &-path {
    margin-bottom: 15px;
  }
  &-block {
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: repeat(2, 592px);
    gap: 16px;
  }
}
</style>
